/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';

const LoadingInline = ({ visible, dim='small' }) => (

    visible ?

        <div className={"ui active inline " + dim + " loader"}></div>
        :
        null
);

LoadingInline.PropTypes = {
    visible: PropTypes.bool,
    dim: PropTypes.string,
}

LoadingInline.defaultProps = {
    dim: 'small'
};

export default LoadingInline;


/** WEBPACK FOOTER **
 ** ./src/components/LoadingInline.jsx
 **/